const agriculture_uischema = {
    view: "main",
    title: "Agricultural Business Profiles",
    entity: "Agricultures",
    linkBack: {
        name: 'Back to Profiles',
        link: '/dashboard/profiles/'
    },
    button: {
        name: 'New Agricultural Business',
        style: 'default'
    }
}

export default agriculture_uischema;